import { render, staticRenderFns } from "./MobileFeed.vue?vue&type=template&id=2ffa5ac4&scoped=true&"
import script from "./MobileFeed.vue?vue&type=script&lang=js&"
export * from "./MobileFeed.vue?vue&type=script&lang=js&"
import style0 from "./MobileFeed.vue?vue&type=style&index=0&id=2ffa5ac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa5ac4",
  null
  
)

export default component.exports